
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Dropdown.css';
import DropdownVendas from './DropdownVendas';
import { usePermissoes } from '../utils/PermissoesContext';

export default function DropdownComercial({ onLinkClick }) {
  const [openNested, setOpenNested] = useState(false);
  const { temPermissao } = usePermissoes();
  
  const toggleNested = (e) => {
    if (window.innerWidth <= 768) {
      e.preventDefault();
      setOpenNested(!openNested);
    }
  };
  
  // Verificar se tem permissão para algum item de vendas
  const temVendas = temPermissao('Vendas') || temPermissao('VendasProdutos');
  
  return (
    <div className="dropdown-submenu-content">
      {temPermissao('Agendamentos') && <Link to="/sidebar/AgendamentosDropdown" onClick={onLinkClick}>Agendamentos</Link>}
      {temPermissao('Calendario') && <Link to="/sidebar/CalendarioDropdown" onClick={onLinkClick}>Calendário</Link>}
      {/* Entregas movido para o menu principal (penúltimo) */}
      {temPermissao('Oportunidade') && <Link to="/sidebar/OportunidadeDropdown" onClick={onLinkClick}>Oportunidades</Link>}
      {temPermissao('Orcamento') && <Link to="/sidebar/OrcamentoDropdown" onClick={onLinkClick}>Orçamento</Link>}
      {temVendas && (
        <div className={`submenu-hover ${openNested ? 'open' : ''}`}>
          <Link to="#" onClick={(e) => toggleNested(e)}>Vendas</Link>
          <DropdownVendas onLinkClick={onLinkClick} />
        </div>
      )}
    </div>
  );
}

